<template>
    <div class="key-documents">
        <template v-if="data.title">
            <z-caption
                weight="500"
                v-html="data.title"
                v-if="!lead"
            ></z-caption>
            <z-lead
                v-else
                class="u-bottom-margin--xxl"
            >
                <span v-html="data.title"></span>
            </z-lead>
        </template>
        <z-filelist v-if="data.items && data.items.length">
            <z-filelist-item
                v-for="(item, index) in data.items"
                :key="index"
                :icon="getIconName(item)"
                :width="width"
                :height="height"
                :info="getFileInfo(item)"
            >
                <z-link
                    :href="item.link"
                    v-html="item.title"
                    blank
                ></z-link>
            </z-filelist-item>
        </z-filelist>
    </div>
</template>
<script>
export default {
    name: 'key-documents',
    props: {
        source: {
            type: String,
            default: 'key-documents'
        },
        inlineData: {
            type: Array,
            default: () => []
        },
        lead: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'file/pdf'
        },
        width: String,
        height: String
    },
    computed: {
        data () {
            return Object.keys(this.inlineData).length ? this.inlineData : this.$root.app.components[this.source]
        }
    },
    methods: {
        getFileInfo (item) {
            if (item.extension && item.size) {
                return `(${item.extension.toUpperCase()}, ${item.size})`
            }

            return ''
        },
        getIconName (item) {
            if (item.extension) {
                return `file/${item.extension.toLowerCase()}`
            }

            return this.icon
        }
    }
}
</script>

<style>
    .key-documents {
        padding-top: 40px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
</style>
